export const hasPermission = (userPermissions, requiredPermission) => {
  if (!userPermissions || !requiredPermission) return false;
  
  // Handle different data structures
  let permissionsArray = userPermissions;
  
  // If permissions is an object, try to extract the array
  if (typeof userPermissions === 'object' && !Array.isArray(userPermissions)) {
    // Check common response structures
    if (userPermissions.data && Array.isArray(userPermissions.data)) {
      permissionsArray = userPermissions.data;
    } else if (userPermissions.permissions && Array.isArray(userPermissions.permissions)) {
      permissionsArray = userPermissions.permissions;
    } else if (userPermissions.items && Array.isArray(userPermissions.items)) {
      permissionsArray = userPermissions.items;
    } else {
      // If it's an object but not a recognized structure, return false
      return false;
    }
  }
  
  // Ensure we have an array before calling includes
  if (!Array.isArray(permissionsArray)) {
    return false;
  }
  
  return permissionsArray.includes(requiredPermission);
};

export const hasAnyPermission = (userPermissions, requiredPermissions) => {
  if (!userPermissions || !requiredPermissions?.length) return false;
  
  // Handle different data structures
  let permissionsArray = userPermissions;
  
  // If permissions is an object, try to extract the array
  if (typeof userPermissions === 'object' && !Array.isArray(userPermissions)) {
    // Check common response structures
    if (userPermissions.data && Array.isArray(userPermissions.data)) {
      permissionsArray = userPermissions.data;
    } else if (userPermissions.permissions && Array.isArray(userPermissions.permissions)) {
      permissionsArray = userPermissions.permissions;
    } else if (userPermissions.items && Array.isArray(userPermissions.items)) {
      permissionsArray = userPermissions.items;
    } else {
      // If it's an object but not a recognized structure, return false
      return false;
    }
  }
  
  // Ensure we have an array before calling includes
  if (!Array.isArray(permissionsArray)) {
    return false;
  }
  
  return requiredPermissions.some(permission => permissionsArray.includes(permission));
};

export const hasAllPermissions = (userPermissions, requiredPermissions) => {
  if (!userPermissions || !requiredPermissions?.length) return false;
  
  // Handle different data structures
  let permissionsArray = userPermissions;
  
  // If permissions is an object, try to extract the array
  if (typeof userPermissions === 'object' && !Array.isArray(userPermissions)) {
    // Check common response structures
    if (userPermissions.data && Array.isArray(userPermissions.data)) {
      permissionsArray = userPermissions.data;
    } else if (userPermissions.permissions && Array.isArray(userPermissions.permissions)) {
      permissionsArray = userPermissions.permissions;
    } else if (userPermissions.items && Array.isArray(userPermissions.items)) {
      permissionsArray = userPermissions.items;
    } else {
      // If it's an object but not a recognized structure, return false
      return false;
    }
  }
  
  // Ensure we have an array before calling includes
  if (!Array.isArray(permissionsArray)) {
    return false;
  }
  
  return requiredPermissions.every(permission => permissionsArray.includes(permission));
};
